import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { isMobile } from "theme/helpers/deviceHelper";
import Skeleton from "theme/components/atoms/Skeleton/Skeleton";

const AdvertisingBanner = ({ data }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isMobileChecked, setIsMobileChecked] = useState(false);

  useEffect(() => {
    if (
      data &&
      isMobileChecked &&
      typeof data.minimum_order_amount !== "undefined"
    ) {
      setIsLoaded(true);
    }
  }, [data, isMobileChecked]);

  useEffect(() => {
    setIsMobileChecked(true);
  }, []);

  const content = (
    <p>
      {!isMobile() && (
        <FormattedMessage
          id="modules.Header.welcomeMessage"
          defaultMessage="Welcome to e-Robertet"
        />
      )}
      {data.minimum_order_amount && (
        <span>
          {isMobile() ? (
            <FormattedMessage
              id="modules.Header.minimumOrderAmount"
              defaultMessage="Minimum order amount {amount} €"
              values={{
                amount: data.minimum_order_amount,
              }}
            />
          ) : (
            <>
              ,{" "}
              <FormattedMessage
                id="modules.Header.minimumOrderAmount"
                defaultMessage="Minimum order amount {amount} €"
                values={{
                  amount: data.minimum_order_amount,
                }}
              />
            </>
          )}{" "}
        </span>
      )}
    </p>
  );

  return (
    <div className="header-banner">
      <div className="header-banner-content">
        <Skeleton isLoaded={isLoaded} width="full" dark={true}>
          {content}
        </Skeleton>
      </div>
    </div>
  );
};

export default AdvertisingBanner;
